(function () {
  function cookieVal(name) {
    const hit = document.cookie.split(';').map((s) => s.trim()).find((s) => s.startsWith(name + '='));
    return hit ? decodeURIComponent(hit.slice(name.length + 1)) : '';
  }

  function currentFbc() {
    const fromCookie = cookieVal('_fbc');
    if (/^fb\.\d+\.\d+\./.test(fromCookie)) return fromCookie;
    const fbclid = new URLSearchParams(location.search).get('fbclid');
    if (!fbclid) return '';
    return `fb.1.${Date.now()}.${fbclid}`;
  }

  function persistFbCookies() {
    const fbp = cookieVal('_fbp');
    const fbc = currentFbc();
    if (!fbp && !fbc) return;
    const attrs = {};
    if (fbp) attrs._fbp = fbp;
    if (fbc) attrs._fbc = fbc;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true,
    }).catch(() => {});
  }

  function whenAnalytics(callback) {
    if (window.Shopify?.analytics?.subscribe) {
      callback();
      return;
    }
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (window.Shopify?.analytics?.subscribe) {
        window.clearInterval(timer);
        callback();
      } else if (tries > 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  whenAnalytics(() => {
    window.Shopify.analytics.subscribe('product_added_to_cart', persistFbCookies);
    window.Shopify.analytics.subscribe('checkout_started', persistFbCookies);
  });

  document.addEventListener('click', (e) => {
    const el = e.target?.closest?.(
      'a[href*="/checkout"], button[name="checkout"], [name="checkout"], [href="/checkout"]'
    );
    if (!el) return;
    persistFbCookies();
  });

  function persistWhenReady() {
    persistFbCookies();
    window.setTimeout(persistFbCookies, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', persistWhenReady);
  } else {
    persistWhenReady();
  }
})();
